import React from "react";
import { AboutContentPiece, AboutComponentProps } from "./Pieces";
export default function AboutComponent(props: AboutComponentProps) {
  return <AboutContentPiece {...props} />;
}
